module.exports = __webpack_public_path__ + "img/footer-logo.a60a7a20.gif";